import "./App.css";
import CardList from "./components/CardList";
// import { useState } from "react";
import About from "./components/About";
import Client from "./components/Client";
import ContactUs from "./components/ContactUs";
import WhyChooseUs from "./components/WhyChooseUs";
import VisionAndMission from "./components/VisionAndMission";
import ScaleUpStrategy from "./components/ScaleUpStrategy";
import Specilization from "./components/Specilization";
// import Nav from "./components/Nav";
import ImageWithText from "./components/ImageWithText";

export default function App() {
  return (
    <div className="min-h-screen bg-cyan relative">
      <ImageWithText />
      <br></br>
      <br></br>
      <div id="AboutUs">
        <About />
      </div>
      <VisionAndMission />

      <div className="container mx-auto mt-10">
        <CardList />
      </div>
      <WhyChooseUs />
      <div className="overflow-hidden h-[75vh] relative">
  <img
    src="solutions/warehouse1.jpg"
    alt="About Us"
    className="w-full h-auto object-cover absolute bottom-0 opacity-90"
  />
</div>
      <ScaleUpStrategy />
      <Specilization />
      <Client />
      <div id="ContactUs">
        <ContactUs />
      </div>
    </div>
  );
}
